import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '@/store';
import type { EndpointLockKeys } from '@/api/core/endpointLocks';

interface EndpointLocksState {
  /** How many mounted components hold each lock on; a lock is on while its count is above zero */
  holders: Partial<Record<EndpointLockKeys, number>>;
}

const initialState: EndpointLocksState = {
  holders: {},
};

const endpointLocksSlice = createSlice({
  name: 'endpointLocks',
  initialState,
  reducers: {
    acquireEndpointLock: (state, action: PayloadAction<EndpointLockKeys>) => {
      state.holders[action.payload] = (state.holders[action.payload] ?? 0) + 1;
    },
    releaseEndpointLock: (state, action: PayloadAction<EndpointLockKeys>) => {
      const holders = (state.holders[action.payload] ?? 0) - 1;

      if (holders > 0) {
        state.holders[action.payload] = holders;
      } else {
        delete state.holders[action.payload];
      }
    },
  },
});

export const { acquireEndpointLock, releaseEndpointLock } = endpointLocksSlice.actions;

export const selectIsEndpointLockActive = (state: RootState, lockId: EndpointLockKeys): boolean =>
  !!state.endpointLocks.holders[lockId];

export const endpointLocksReducer = endpointLocksSlice.reducer;
